import { FiltersWrapper } from './FiltersWrapper';
import { Select } from 'foundations-components/components/Select';
import I18n from 'I18n';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function DropdownContentSourceFilter({
  appearsIn
}) {
  const [contentSourceParams, setContentSource] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  const handleFilterChange = selected => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value: selected,
      key: 'content-source-filter',
      appearsIn,
      isDropdown: true
    });
    if (selected.includes('ALL_CONTENT')) {
      setContentSource(undefined);
    } else {
      setContentSource(selected);
    }
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('learningCenter.topFilters.contentSource.filterTitle'),
      clearable: true,
      menuInlineSize: 200,
      menuMaxBlockSize: 400,
      multi: false,
      onSelectedOptionChange: evt => {
        handleFilterChange(evt.selectedValues);
      },
      options: [{
        text: I18n.text('learningCenter.topFilters.contentSource.ALL_CONTENT'),
        value: 'ALL_CONTENT'
      }, {
        text: I18n.text('learningCenter.topFilters.contentSource.CUSTOM_CONTENT'),
        value: 'CUSTOM_CONTENT'
      }, {
        text: I18n.text('learningCenter.topFilters.contentSource.ACADEMY'),
        value: 'ACADEMY'
      }],
      selectedItemsPlaceholder: I18n.text('learningCenter.topFilters.contentSource.filterTitle'),
      selectedValues: contentSourceParams
    })
  });
}